import React from "react";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {ElementChip} from "./base/ElementChip";
import {getReservationStatusColor} from "./colors";
import {isReservationVisuallyInactive} from "./utils";

type ReservationStatusElementProps = {
    status: ReservationStatus | undefined;
    start?: string | Date;
    end?: string | Date;
    asPrint?: boolean;
};

export function ReservationStatusElement({
    status,
    start,
    end,
    asPrint = false,
}: ReservationStatusElementProps) {
    const {t} = useTranslation();

    if (!status) {
        return null;
    }

    const text = t(`Reservation status ${status}`);

    if (asPrint) {
        return <>{text}</>;
    }

    const visuallyInactive = isReservationVisuallyInactive(status, start, end, new Date());

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%", opacity: visuallyInactive ? 0.5 : 1}}>
            <ElementChip
                text={text}
                startIcon={
                    <Box
                        component="span"
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: getReservationStatusColor(status),
                            flex: "0 0 auto",
                        }}
                    />
                }
            />
        </Box>
    );
}
